"use client";

import styled from "styled-components";

interface CardProps {
  $gap?: string;
  $heightFullScreen?: boolean;
  $heightFull?: boolean;
  $align?: "start" | "center" | "end" | "stretch" | "baseline";
  $justify?:
    | "start"
    | "center"
    | "end"
    | "space-between"
    | "space-around"
    | "space-evenly";
}

export const Card = styled.div<CardProps>`
  width: 100%;
  padding: 1.5rem;
  background: var(--backgroundColorCard);
  border-radius: 1rem;
  border: 1px solid var(--shadow);
  box-shadow: 0 0 6px -5px var(--shadow);
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${({ $gap }) => $gap || `0`};
  min-height: ${({ $heightFullScreen }) =>
    $heightFullScreen && `calc(100vh - 164px)`};
  height: ${({ $heightFull }) => $heightFull && `100%`};
  ${({ $align }) =>
    $align &&
    `align-items: ${$align === "start" ? "flex-start" : $align === "end" ? "flex-end" : $align};`}
  ${({ $justify }) =>
    $justify &&
    `justify-content: ${$justify === "start" ? "flex-start" : $justify === "end" ? "flex-end" : $justify};`}
`;
